module.exports = __webpack_public_path__ + "static/media/reshape_white_small.7aed2e38.svg";